export default __webpack_public_path__ + "static/value3-f04294dad1cb52d571447ed4f0a50adf.webp";